<template>
  <b-modal id="reportExpired"
           ref="reportExpired"
           size="lg"
           title="This report has expired"
           :hide-footer="true"
           :no-close-on-backdrop="true">
    <b-row>
      <b-col v-if="contact" lg="12" class="pr-5 pl-5">
        <p class="lead">The report you have requested is now out of date.</p>
        <p class="lead">We update our market data every 30 days to ensure the information and advice we provide is always current.</p>
        <p class="mb-3 lead">Please contact {{ contact.author_name }} at {{ contact.company }} to request a current market report {{ contact.email }}</p>
        <p class="lead text-center pt-3"><a :href="`mailto:${contact.email}`"><strong>{{ contact.email }}</strong></a></p>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import bus from '../../plugins/bus'
import { mapState } from 'vuex'
export default {
  name: 'ReportExpiredModal',
  mounted () {
    bus.on('ReportExpired', this.showExpiredModal)
  },
  computed: {
    ...mapState({
      contact: state => state.report.expiredReportContact,
    }),
  },
  methods: {
    showExpiredModal () {
      if (this.contact) {
        document.body.classList.add('blurred')
        this.$refs.reportExpired.show()
      }
      if (this.contact === null) {
        document.body.classList.remove('blurred')
        this.$refs.reportExpired.hide()
        this.$router.push('/not-found')
      }
    },
  },
  beforeDestroy () {
    bus.off('reportExpired')
  },
}
</script>

<style>
  #reportExpired {
    font-family: "averta", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif !important;
  }
  #reportExpired .modal-title {
    font-size: 1.5rem;
  }
  #reportExpired .btn-primary { /* TODO: This is a global style */
    color: #fff;
    background-color: #112130;
    border-color: #112130;
  }
  #reportExpired .modal-dialog {
    max-width: 35%!important;
    /*margin-top: 7rem;*/
  }
  @media screen and (max-width: 575px){
    #reportExpired .modal-dialog {
      max-width: 95%!important;
      margin: 10% auto 0 auto;
    }
  }
  #reportExpired button {
   display: none;
  }
  #reportExpired .lead {
    color: #85868a;
    font-family: Roboto,sans-serif;
    font-size: 1.25rem;
    font-weight: 300;
  }
</style>
